import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckinBaseComponent } from '@common/components/checkin-base-class';
import { SeatmapResultStoreService } from '@common/services';
import { CheckinCommonStoreService } from '@common/services/checkin-common-store/checkin-common-store.service';
import { CprResultStoreService } from '@common/services/cpr-result-store/cpr-result-store.service';
import { PREVIOUS_PAGE_IDENTIFIER } from '@conf/previous-page-identifier.config';
import { CHECKIN_ROUTES } from '@conf/routes.config';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-checkin-seatmap-sub-header',
  templateUrl: './checkin-seatmap-sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckinSeatmapSubHeaderComponent extends CheckinBaseComponent {
  /** ページタイトル */
  pageTitle?: string;

  /** 戻り先URL */
  backUrl = '';

  constructor(
    commonService: CommonLibService,
    private checkinCommonStoreService: CheckinCommonStoreService,
    private seatmapResultStoreService: SeatmapResultStoreService,
    private cprResultStoreService: CprResultStoreService
  ) {
    super(commonService);
  }

  override reload(): void {}

  override init(): void {
    const previousPageIdentifier = this.checkinCommonStoreService.checkinCommon.previousPageIdentifier;
    if (previousPageIdentifier === PREVIOUS_PAGE_IDENTIFIER.CHECKIN_REVIEW) {
      this.backUrl = CHECKIN_ROUTES.checkinReview;
    } else if (previousPageIdentifier === PREVIOUS_PAGE_IDENTIFIER.CHECKIN_STATUS) {
      this.backUrl = CHECKIN_ROUTES.checkinMybooking;
    }
  }

  override destroy(): void {}

  clear() {
    this.seatmapResultStoreService.clear();
    this.cprResultStoreService.clearCprResult();
  }
}
